var _circle, _g, _circle2, _g2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5764_9366",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E64771"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5764_9366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8997 31.9831L7.13135 32C3.2223 32.0035 0.0213251 28.8088 0.016883 24.8997L2.96183e-06 7.13135C-0.00355072 3.2223 3.19121 0.0213251 7.10025 0.016883L24.8686 2.96183e-06C28.7777 -0.00355072 31.9787 3.19121 31.9831 7.10025L32 24.8686C32.0044 28.7786 28.8088 31.9796 24.8997 31.9831Z",
    fill: "url(#paint0_radial_5764_9366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8997 31.9831L7.13135 32C3.2223 32.0035 0.0213251 28.8088 0.016883 24.8997L2.96183e-06 7.13135C-0.00355072 3.2223 3.19121 0.0213251 7.10025 0.016883L24.8686 2.96183e-06C28.7777 -0.00355072 31.9787 3.19121 31.9831 7.10025L32 24.8686C32.0044 28.7786 28.8088 31.9796 24.8997 31.9831Z",
    fill: "url(#paint1_radial_5764_9366)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5764_9366",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E64771"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5764_9366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8997 31.9831L7.13135 32C3.2223 32.0035 0.0213251 28.8088 0.016883 24.8997L2.96183e-06 7.13135C-0.00355072 3.2223 3.19121 0.0213251 7.10025 0.016883L24.8686 2.96183e-06C28.7777 -0.00355072 31.9787 3.19121 31.9831 7.10025L32 24.8686C32.0044 28.7786 28.8088 31.9796 24.8997 31.9831Z",
    fill: "url(#paint2_radial_5764_9366)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8766 20.4114C13.3772 20.4114 11.3428 18.3776 11.3428 15.8776C11.3428 13.3775 13.3772 11.3438 15.8766 11.3438C18.376 11.3438 20.4104 13.3775 20.4104 15.8776C20.4104 18.3776 18.376 20.4114 15.8766 20.4114ZM15.8766 12.6391C14.0909 12.6391 12.6381 14.0919 12.6381 15.8776C12.6381 17.6632 14.0909 19.116 15.8766 19.116C17.6623 19.116 19.115 17.6632 19.115 15.8776C19.115 14.0919 17.6623 12.6391 15.8766 12.6391Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7342 11.9899C21.2708 11.9899 21.7058 11.555 21.7058 11.0184C21.7058 10.4818 21.2708 10.0469 20.7342 10.0469C20.1977 10.0469 19.7627 10.4818 19.7627 11.0184C19.7627 11.555 20.1977 11.9899 20.7342 11.9899Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7626 24.2969H11.9904C9.49093 24.2969 7.45654 22.2632 7.45654 19.7631V11.9908C7.45654 9.49077 9.49093 7.45703 11.9904 7.45703H19.7626C22.262 7.45703 24.2964 9.49077 24.2964 11.9908V19.7631C24.2964 22.2632 22.262 24.2969 19.7626 24.2969ZM11.9904 8.75241C10.2047 8.75241 8.75192 10.2052 8.75192 11.9908V19.7631C8.75192 21.5488 10.2047 23.0015 11.9904 23.0015H19.7626C21.5483 23.0015 23.0011 21.5488 23.0011 19.7631V11.9908C23.0011 10.2052 21.5483 8.75241 19.7626 8.75241H11.9904Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5764_9366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8959 32.0231) scale(39.8892 39.8892)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5764_9366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.14928 -0.399517) scale(26.4865 17.6479)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5764_9366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.14928 -0.399517) scale(26.4865 17.6479)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.5659cf3f4434c461ecaf5201e4bd74ae.svg";
export { ForwardRef as ReactComponent };